import { CalendarDays, Coins, Gauge, Info, ListChecks, Monitor, ShieldCheck } from "lucide-react";
import type { PlatformItem } from "../types/navigator";
import { sensitivityInfo } from "../utils/platformSensitivity";
import { DetailRow, GlanceCell, Row, formatDetailDate } from "./DetailParts";

export function PlatformDetails({ item }: { item: PlatformItem }) {
  const sensitivity = sensitivityInfo(item);
  return (
    <div className="ini">
      <div className="ini-glance">
        <div className="ini-glance-row">
          <GlanceCell icon={ShieldCheck} label="Data classification" wide>
            <span className={`ini-classify ini-classify--${sensitivity.key}`}>
              <span className="ini-classify-dot" aria-hidden />
              {sensitivity.label}
            </span>
          </GlanceCell>
          {item.platformType ? (
            <GlanceCell icon={Monitor} label="Platform type">
              {item.platformType}
            </GlanceCell>
          ) : null}
          {item.complexity ? (
            <GlanceCell icon={Gauge} label="Complexity">
              {item.complexity}
            </GlanceCell>
          ) : null}
          {item.costModel ? (
            <GlanceCell icon={Coins} label="Cost model">
              {item.costModel}
            </GlanceCell>
          ) : null}
        </div>
      </div>

      <dl className="ini-rows">
        <Row icon={Info} label="What it is" text={item.purpose} />
        <Row icon={ListChecks} label="Key capabilities" text={item.keyCapabilities} />
      </dl>

      <section className="ini-section">
        <h4 className="ini-section-title">
          <CalendarDays size={13} aria-hidden /> Details
        </h4>
        <dl className="ini-details">
          <DetailRow label="Status" value={item.status} />
          <DetailRow label="License / plan" value={item.licenseType} />
          <DetailRow label="Approved use" value={item.approvedUse} />
          <DetailRow label="Used by broader Brookfield" value={item.usedByBroaderBrookfield} />
          <DetailRow label="Last updated" value={formatDetailDate(item.modified)} />
        </dl>
      </section>
    </div>
  );
}
